module.exports = __webpack_public_path__ + "static/media/fiat.b6fc8d83.svg";